<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='$store.state.icons.modules.clients.title'
            :titleIcon='$store.state.icons.modules.clients.icon'
            :titleIconColor='$store.state.icons.modules.clients.color'
            showAdd
            @add='addClient'
          >
          <template v-slot:appendTitle>
            <v-tooltip top open-delay='500'>
              <template v-slot:activator='{ on }'>
                <v-btn
                  v-if='!clients.length'
                  v-on='on'
                  x-small
                  class='ml-6 white--text'
                  elevation='0'
                  :color='$store.state.icons.modules.clients.color'
                  @click='getClients'
                  :loading='isLoading'
                >Load all Clients</v-btn>
              </template>
              <span class='caption'>This may take a few seconds</span>
            </v-tooltip>
          </template>
            <template v-slot:toolbarButtons>
              <wc-show-archived-button
                v-model='showArchived'
                @toggleShowArchived='showArchived = !showArchived'
              ></wc-show-archived-button>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              :headers='headers'
              :items='filteredClients'
              :search='search'
              :loading='isLoading'
              no-data-text="Client data doesn't load automatically.  In general, please use search at top right of the page."
              dense
              sort-by='name_display'
              @click:row='openClient'
              :items-per-page='25'
            >
              <template v-slot:item.name_display='{ item }'>
                {{ item.name_display }}
                  <v-icon
                    v-if='item.is_company'
                    small
                    :color='$store.state.icons.dataBox.company.iconColor'
                  >
                    {{ $store.state.icons.dataBox.company.icon }}
                  </v-icon>
                <wc-archived v-if='item.archived'></wc-archived>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
<!-- add new below -->
    <wc-dialog
      :showDialog='showDialog'
      :title='dialogTitle'
      :icon='$store.state.icons.modules.clients.icon'
      :iconColor='$store.state.icons.modules.clients.color'
      @cancel='cancelAdd'
      @save='saveNewClient'
      :loading='isLoading'
      :disableButtons='!isFormValid'
    >
      <v-form v-model="isFormValid" ref='form'>
        <v-row>
          <v-col cols='12'>
            <v-select ref='focus' label='Company or Individual?' :items='businessIndividualToggle' v-model='newClient.is_company'></v-select>
          </v-col>
          <v-col cols='12' v-if="newClient.is_company">
            <v-checkbox
              label='Create commercial contact?'
              v-model='has_commercial_contact'
            ></v-checkbox>
          </v-col>
          <v-col cols='12' :sm="newClient.is_company ? '12' : '6'">
            <v-text-field :label="newClient.is_company ? 'Company name' : 'First Name'" v-model='newClient.name'></v-text-field>
          </v-col>
          <v-col cols='12' sm='6' v-if='!newClient.is_company'>
            <v-text-field label='Last name' :rules='[rules.required]' v-model='newClient.last_name'></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field label='Email' :rules='[rules.email]' v-model='newClient.email' prepend-icon='mdi-email'></v-text-field>
          </v-col>
          <v-col cols='12' :sm="newClient.is_company ? '12' : '4'">
            <v-text-field :label="newClient.is_company ? 'Phone' : 'Work phone'" v-model='newClient.work_phone' prepend-icon='mdi-deskphone' :rules='[rules.phoneNumber]'></v-text-field>
          </v-col>
          <v-col cols='12' sm='4' v-if='!newClient.is_company'>
            <v-text-field label='Cell phone' v-model='newClient.cell_phone' prepend-icon='mdi-cellphone' :rules='[rules.phoneNumber]'></v-text-field>
          </v-col>
          <v-col cols='12' sm='4' v-if='!newClient.is_company'>
            <v-text-field label='Home phone' v-model='newClient.home_phone' prepend-icon='mdi-phone-classic' :rules='[rules.phoneNumber]'></v-text-field>
          </v-col>
          <v-col cols='12' sm='8'>
            <v-text-field label='Address' v-model='newClient.address'></v-text-field>
          </v-col>
          <v-col cols='12' sm='4'>
            <v-text-field label='City' v-model='newClient.city'></v-text-field>
          </v-col>
          <v-col cols='12' sm='4'>
            <v-text-field label='Province' v-model='newClient.province'></v-text-field>
          </v-col>
          <v-col cols='12' sm='4'>
            <v-text-field label='Country' v-model='newClient.country'></v-text-field>
          </v-col>
          <v-col cols='12' sm='4'>
            <wc-postal-code-input v-model='newClient.postal'></wc-postal-code-input>
          </v-col>
          <v-col cols="12" md="6">
            <client-form-search v-if='!newClient.is_company'
                v-model='newClient.works_for'
                label='Works for' />
          </v-col>
          <template v-if="newClient.is_company && has_commercial_contact">
            <div style="text-align: 'left', border: 1px solid black">Commercial Contact</div>
            <v-col cols='12'>
                <v-checkbox label='Existing contact?' v-model='existing_contact'></v-checkbox>
            </v-col>
            <template v-if="existing_contact">
                <v-col cols='12' md='12'>
                <client-form-search
                    v-model='commercial_contact.contact'
                    label='Commercial Contact'
                />
            </v-col>
            </template>
            <template v-else>
                <v-col cols='12' md="6">
                    <v-text-field
                    label='First name'
                    v-model='commercial_contact_client.name'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='6'>
                    <v-text-field
                    label='Last name'
                    v-model='commercial_contact_client.last_name'
                    ></v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                    label='Address'
                    v-model='commercial_contact_client.address'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='6'>
                    <v-text-field
                    label='City'
                    v-model='commercial_contact_client.city'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='3'>
                    <v-text-field
                    label='Province'
                    v-model='commercial_contact_client.province'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='3'>
                    <wc-postal-code-input
                    v-model='commercial_contact_client.postal'
                    ></wc-postal-code-input>
                </v-col>
                <v-col cols='12' md='6'>
                    <v-text-field
                    label='Email'
                    :rules='[rules.email]'
                    prepend-icon='mdi-email'
                    v-model='commercial_contact_client.email'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='6'>
                    <phone-number-field
                    label='Main Phone'
                    :phone='commercial_contact_client.work_phone !== null ? commercial_contact_client.work_phone : ""'
                    icon='mdi-phone'
                    @update='updateCommContactPhoneNumber'
                    ></phone-number-field>
                </v-col>
            </template>
            <v-col cols='12' md='6'>
            <v-text-field
                label='Position'
                v-model='commercial_contact.position'
            ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-checkbox label="Is Main Contact?" v-model="commercial_contact.main_contact"></v-checkbox>
            </v-col>
        </template>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import clientsAPI from '@/modules/clients/api/clients'
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import PhoneNumberField from '@/components/forms/PhoneNumberField';
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput'

export default {
  name: 'clients-dashboard',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    commercial_contact: {contact: 0, is_main_contact: false, client: 0, position: ""},
    commercial_contact_client: {},
    existing_contact: true,
    has_commercial_contact: false,
    search: '',
    showArchived: false,
    showDialog: false,
    isFormValid: true,
    newClient: {},
    resetClient: {
      name: "",
      last_name: "",
      is_company: false,
      is_client: false,
      is_vendor: false,
      archived: false,
      email: "",
      home_phone: "",
      cell_phone: "",
      work_phone: "",
      address: "",
      city: "",
      province: "",
      postal: "",
      country: "",
      works_for: "",
    },
    clients: [],
    businessIndividualToggle: [
      { text: 'Individual', value: false },
      { text: 'Company', value: true }
    ],
    headers: [
      { text: 'Name', value: 'name_display' },
      { text: 'Address', value: 'address' },
      { text: 'City', value: 'city' },
      { text: 'Email', value: 'email' },
      { text: 'Phone', value: 'main_phone' },
      { text: 'Cell', value: 'cell_phone' }
    ]
  }),
  computed: {
    filteredClients () {
      return this.showArchived ? _.orderBy(this.clients, 'name') : _.orderBy(this.clients.filter(c => c.archived === false), 'name')
    },
    dialogTitle () {
      return "Create a new client : " + (this.newClient.is_company ? 'Company' : 'Individual')
    },
  },
  created () {
    // this.getClients()
    this.resetAdd()
  },
  methods: {
    async getClients () {
      this.isLoading = true
      this.clients = await clientsAPI.getClients()
      this.isLoading = false
    },
    async saveNewClient () {
      const client = await clientsAPI.createClient(this.newClient)

      if(this.has_commercial_contact){
        if(!this.existing_contact){
            this.commercial_contact_client.works_for = client.id;
            let newCommercialContactClient = await clientsAPI.createClient(this.commercial_contact_client);
            this.commercial_contact.contact = newCommercialContactClient.id;
        }
        else{
            clientsAPI.updateClient({id: this.commercial_contact.contact, works_for: client.id});
        }
        this.commercial_contact.client = client.id;
        await clientsAPI.createClientContact(this.commercial_contact);
      }

      this.openClient(client)
    },
    addClient () {
      this.showDialog = true
      this.resetAdd()
      setTimeout(() => {
        this.$refs.form.resetValidation()
      }, 50)
      setTimeout(() => {
        this.$refs.focus.focus()
      }, 100)
    },
    cancelAdd () {
      this.showDialog = false
    },
    resetAdd() {
      this.newClient = _.cloneDeep(this.resetClient)
    },
    openClient (client) {
      this.$router.push({ name: 'ClientOverview', params: { id: client.id } })
    },
    updateCommContactPhoneNumber(phone){
        this.commercial_contact_client.cell_phone = phone;
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput,
    'phone-number-field': PhoneNumberField,
    'client-form-search': () => import('@/modules/clients/components/ClientFormSearch')
  }
}
</script>
